import {
  Component,
  Input,
  OnDestroy,
  ElementRef,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CreateTicketComponent } from 'src/app/tickets/containers';
import * as fromStore from 'src/app/store/';
import { Permission } from 'src/app/shared/constants/permissions';

@Component({
    selector: 'app-help-cta',
    templateUrl: './help-cta.component.html',
    standalone: false
})
export class HelpCtaComponent implements OnDestroy {
  @Input() originPage: string;

  @Input() hasInvoice: boolean;

  browserSize$: Observable<string>;

  browserSize: string;

  toggleHelpBlimpButton: ElementRef;

  Permission = Permission;

  @ViewChild('helpCtaRoot', { static: false }) helpCtaRoot!: ElementRef;

  @ViewChild('helpBlimpView', { static: false }) helpBlimpView!: ElementRef;

  private readonly destroy$ = new Subject<void>();

  private unlistenWindowClick: (() => void) | null = null;

  private showBlimpSubject = new BehaviorSubject<boolean>(false);

  showBlimp$ = this.showBlimpSubject.asObservable();

  constructor(
    private dialog: MatDialog,
    private store: Store<fromStore.State>,
    private renderer: Renderer2,
  ) {
    this.browserSize$ = this.store.select(fromStore.getBrowserSizeName);

    this.browserSize$.pipe(takeUntil(this.destroy$)).subscribe((name) => {
      if (name) {
        this.browserSize = name;
      }
    });

    // Close help blimp if clicked outside (desktop only)
    this.unlistenWindowClick = this.renderer.listen(
      'document',
      'click',
      (e: Event) => {
        const target = e.target as Node;
        const insideRoot = this.helpCtaRoot?.nativeElement.contains(target);
        const insideBlimp = this.helpBlimpView?.nativeElement.contains(target);
        if (!insideRoot && !insideBlimp) {
          this.closeBlimp();
        }
      },
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.unlistenWindowClick) this.unlistenWindowClick();
  }

  onCreateTicket(): void {
    // Open the create ticket dialog
    const dialogConfig = {
      autoFocus: true,
      minHeight: this.browserSize === 'small' ? '315px' : '380px',
      width: this.browserSize === 'small' ? 'calc(100vw - 20px)' : '650px',
      maxWidth: '650px',
      data: {
        browserSize: this.browserSize,
        originPage: this.originPage,
      },
      disableClose: true,
    };

    const createTicketDialog = this.dialog.open(
      CreateTicketComponent,
      dialogConfig,
    );
    createTicketDialog.afterClosed().subscribe();
  }

  toggleBlimp(): void {
    this.showBlimpSubject.next(!this.showBlimpSubject.value);
  }

  closeBlimp(): void {
    this.showBlimpSubject.next(false);
  }
}
